class Format {
  width
  height
  units

  constructor (widthOrFormat, height, units) {
    if (typeof widthOrFormat === 'number') {
      this.width = widthOrFormat
      this.height = height
      this.units = units
    } else {
      this.width = widthOrFormat.width
      this.height = widthOrFormat.height
      this.units = widthOrFormat.units
    }
  }

  get name () {
    if (this.width === 210 && this.height === 297) return 'A4'
    if (this.width === 148 && this.height === 210) return 'A5'
    if (this.width === 105 && this.height === 148) return 'A6'
    if (this.width === 128 && this.height === 188) return '単行本'
    return 'Custom'
  }

  getCssWidth () {
    return `${this.width}${this.units}`
  }

  getCssHeight () {
    return `${this.height}${this.units}`
  }

  toObject () {
    return JSON.parse(JSON.stringify(this))
  }
}

export { Format }
